var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "jade-feedback",
    {
      attrs: {
        title: _vm.$t("title"),
        description: _vm.$t("description"),
        variant: "positive",
      },
    },
    [
      _c(
        "jade-button",
        { attrs: { size: "small" }, on: { click: _vm.goToDisputes } },
        [_vm._v(_vm._s(_vm.$t("button")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }